/**
 * Returns the pathname from a payload path, dropping search and hash.
 * Cached `__NUXT_DATA__` must not embed query params.
 *
 * A query-less `payload.path` makes Nuxt append `window.location.search`
 * instead of applying a cached query to the address bar.
 */
export function toCanonicalPayloadPath(path: string): string {
  const hashIndex = path.indexOf("#");
  const withoutHash = hashIndex === -1 ? path : path.slice(0, hashIndex);
  const qIndex = withoutHash.indexOf("?");
  return qIndex === -1 ? withoutHash : withoutHash.slice(0, qIndex);
}
